
export const navLinks = [
    { navLinkId: "Over mij", scrollToId: "aboutContainer" },
    { navLinkId: "Vaardigheden", scrollToId: "skillsContainer" },
    { navLinkId: "Werkervaring", scrollToId: "jobsContainer" },
    { navLinkId: "Opleidingen", scrollToId: "educationContainer" },
    { navLinkId: "Contact", scrollToId: "contactContainer", cta: true },
];